// Local storage
const getItemFromStore = (key, defaultValue, store = localStorage) => {
  try {
    return JSON.parse(store.getItem(key)) || defaultValue;
  } catch (e) {
    localStorage.removeItem(key);
    return false;
  }
};

const setItemToStore = (key, payload, store = localStorage) =>
  store.setItem(key, JSON.stringify(payload));

// Token handling
export const tokenKey = "tk";

export const setToken = (newToken) => {
  setItemToStore(tokenKey, newToken);
};

export const removeToken = () => {
  localStorage.removeItem(tokenKey);
};

// Returns the decoded payload, or null when the value is not a JWT. Callers
// run at module load, so this must never throw: a malformed token would
// otherwise crash the bundle before the app can redirect to the login page.
export const parseJwt = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};

const readValidToken = () => {
  const token = getItemFromStore(tokenKey);
  if (typeof token === "string" && parseJwt(token)) return token;
  if (token) removeToken();
  return null;
};

export const storedToken = readValidToken();
